import { useState, useCallback, useMemo } from 'react';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';

import { KEYBOARD_KEYS } from '@CommonConstants';

import { CHOICE_KEYS, CHOICE_RESULT_KEYS, ITEM_TEXT_DELIMITER_TYPE } from '@Services/Editor/Constants';

import {
  // useItemNames,
  usePropertyTextByType,
  setChoiceVisibleConditionItems,
  setChoiceRequired,
  setRequiredSponsorCookie,
  setChoiceResultStoreProperty,
  setChoiceResultDestroyProperty,
  setResultRequiredItemsCondition,
  updateChoicePropertyChipState,
  updateResultPropertyChipState,
  deleteChoiceProperty,
  deleteChoiceResultProperty,
  setIfs,
} from '@Services/Editor';

const useAutoComplete = (snackBarRef, type, processId, choiceId, handleCloseContextMenuClick, resultId = null) => {
  const dispatch = useDispatch();
  // const itemElements = useSelector(useItemNames, shallowEqual);

  const proceesses = useSelector(state => state.editor.processes, shallowEqual);
  const propertyText = useSelector(usePropertyTextByType(type, processId, choiceId, resultId), shallowEqual);
  const [searchKeyword, setSearchKeyword] = useState('');
  // const isCanItemAdd = type === CHOICE_RESULT_KEYS.STORE;
  // const getIsIncludedItem = itemName => {
  //   const splittedItemName = itemName.includes(ITEM_TEXT_DELIMITER_TYPE.MULTIPLE_ITEM)
  //     ? itemName.split(ITEM_TEXT_DELIMITER_TYPE.MULTIPLE_ITEM)[0]
  //     : itemName;
  //   return itemElements.find(name => name === splittedItemName);
  // };

  // const getAllItems = () => {};

  function extractItemsFromProcesses(proceessesData) {
    const answer = [];

    proceessesData.forEach(process => {
      process.choices.forEach(choice => {
        choice.results.forEach(result => {
          if (result.store) {
            result.store.forEach(item => {
              answer.push(item.name);
            });
          }

          if (result.destroy) {
            result.destroy.forEach(item => {
              answer.push(item.name);
            });
          }

          if (result.resultPropertyChipState && result.resultPropertyChipState.requiredItems) {
            result.resultPropertyChipState.requiredItems.split(',').forEach(item => {
              answer.push(item.trim());
            });
          }
        });

        if (choice.hide && choice.hide.ifHaveNot) {
          choice.hide.ifHaveNot.forEach(hideItem => {
            hideItem.items.forEach(item => {
              answer.push(item.name);
            });
          });
        }

        if (choice.required) {
          choice.required.forEach(requiredItem => {
            answer.push(requiredItem.name);
          });
        }
      });
    });

    return [...new Set(answer)];
  }

  const answer = useMemo(() => extractItemsFromProcesses(proceesses), [proceesses]);
  const showAddItemSnackBar = itemName => {
    if (!itemName) {
      return;
    }
    const hasItem = answer.includes(itemName);

    if (!hasItem) {
      snackBarRef.current.show({
        text: `"${itemName}" 아이템 추가됨`,
      });
    }

    handleCloseContextMenuClick();
  };

  const showRequiredSponsorCookieSnackBar = cookie => {
    if (!Number(cookie)) {
      return;
    }
    snackBarRef.current.show({
      text: `${cookie} 쿠키 추가`,
    });

    handleCloseContextMenuClick();
  };

  // const showCanNotAddItemSnackBar = () => {
  //   snackBarRef.current.show({
  //     text: '아이템은 도착지 > 얻는 아이템에서 추가해 주세요.',
  //   });
  //   handleCloseContextMenuClick();
  // };

  // const getCanEnteredAddItemName = itemName => {
  //   if (!itemName) {
  //     return true;
  //   }

  //   if (isCanItemAdd) {
  //     return itemName;
  //   }

  //   const isIncludedItem = getIsIncludedItem(itemName);

  //   if (isIncludedItem) {
  //     return itemName;
  //   }

  //   return false;
  // };

  const handleDispatchProperty = useCallback(() => {
    switch (type) {
      case CHOICE_KEYS.HIDE: {
        dispatch(setChoiceVisibleConditionItems({ processId, choiceId }));
        break;
      }

      case CHOICE_KEYS.REQUIRED: {
        dispatch(setChoiceRequired({ processId, choiceId }));
        break;
      }

      case CHOICE_KEYS.REQUIRED_SPONSOR_COOKIE: {
        dispatch(setRequiredSponsorCookie({ processId, choiceId }));
        break;
      }

      case CHOICE_RESULT_KEYS.STORE: {
        dispatch(setChoiceResultStoreProperty({ processId, choiceId, resultId }));
        break;
      }

      case CHOICE_RESULT_KEYS.REQUIRED_ITEMS: {
        dispatch(setIfs({ processId, choiceId, resultId }));
        break;
      }

      case CHOICE_RESULT_KEYS.DESTROY: {
        dispatch(setChoiceResultDestroyProperty({ processId, choiceId, resultId }));
        break;
      }

      case CHOICE_RESULT_KEYS.CHOICE_RESULT_KEYS: {
        dispatch(setResultRequiredItemsCondition({ processId, choiceId, resultId }));
        break;
      }

      default:
        break;
    }
    setSearchKeyword('');
  }, [type, searchKeyword, dispatch]);

  // const handleDispatchProperty = useCallback(() => {
  //   switch (type) {
  //     case CHOICE_KEYS.HIDE: {
  //       dispatch(setChoiceVisibleConditionItems({ processId, choiceId }));
  //       break;
  //     }

  //     case CHOICE_KEYS.REQUIRED: {
  //       dispatch(setChoiceRequired({ processId, choiceId }));
  //       break;
  //     }

  //     case CHOICE_KEYS.REQUIRED_SPONSOR_COOKIE: {
  //       dispatch(setRequiredSponsorCookie({ processId, choiceId }));
  //       break;
  //     }

  //     case CHOICE_RESULT_KEYS.STORE: {
  //       dispatch(setChoiceResultStoreProperty({ processId, choiceId, resultId }));
  //       break;
  //     }

  //     case CHOICE_RESULT_KEYS.DESTROY: {
  //       dispatch(setChoiceResultDestroyProperty({ processId, choiceId, resultId }));
  //       break;
  //     }

  //     case CHOICE_RESULT_KEYS.CHOICE_RESULT_KEYS: {
  //       dispatch(setResultRequiredItemsCondition({ processId, choiceId, resultId }));
  //       break;
  //     }

  //     default:
  //       break;
  //   }
  //   setSearchKeyword('');
  // }, [type, searchKeyword, dispatch]);

  const handleDispatchPropertyText = useCallback(
    text => {
      const isChoiceProperty =
        type === CHOICE_KEYS.HIDE || type === CHOICE_KEYS.REQUIRED || type === CHOICE_KEYS.REQUIRED_SPONSOR_COOKIE;
      if (isChoiceProperty) {
        dispatch(updateChoicePropertyChipState({ processId, choiceId, type, state: text }));
      } else {
        dispatch(
          updateResultPropertyChipState({
            processId,
            choiceId,
            resultId,
            type,
            state: text,
          }),
        );
      }
    },
    [type, dispatch],
  );

  const onDelete = useCallback(() => {
    switch (type) {
      case CHOICE_KEYS.HIDE: {
        dispatch(deleteChoiceProperty({ processId, choiceId, type: CHOICE_KEYS.HIDE }));
        break;
      }

      case CHOICE_KEYS.REQUIRED: {
        dispatch(deleteChoiceProperty({ processId, choiceId, type: CHOICE_KEYS.REQUIRED }));
        break;
      }

      case CHOICE_KEYS.REQUIRED_SPONSOR_COOKIE: {
        dispatch(deleteChoiceProperty({ processId, choiceId, type: CHOICE_KEYS.REQUIRED_SPONSOR_COOKIE }));
        break;
      }

      case CHOICE_RESULT_KEYS.STORE: {
        dispatch(
          deleteChoiceResultProperty({
            processId,
            choiceId,
            resultId,
            type: CHOICE_RESULT_KEYS.STORE,
          }),
        );
        dispatch(
          deleteChoiceResultProperty({
            processId,
            choiceId,
            resultId,
            type: CHOICE_RESULT_KEYS.STORE_HIDDEN,
          }),
        );

        break;
      }

      case CHOICE_RESULT_KEYS.DESTROY: {
        dispatch(deleteChoiceResultProperty({ processId, choiceId, resultId, type: CHOICE_RESULT_KEYS.DESTROY }));
        dispatch(
          deleteChoiceResultProperty({ processId, choiceId, resultId, type: CHOICE_RESULT_KEYS.DESTROY_HIDDEN }),
        );
        break;
      }

      case CHOICE_RESULT_KEYS.REQUIRED_ITEMS: {
        dispatch(
          deleteChoiceResultProperty({ processId, choiceId, resultId, type: CHOICE_RESULT_KEYS.REQUIRED_ITEMS }),
        );
        break;
      }

      default:
        break;
    }
  }, [type, dispatch]);

  // const onChange = event => {
  //   const {
  //     target: { value },
  //   } = event;

  //   setSearchKeyword(value.split(ITEM_TEXT_DELIMITER_TYPE.SPLIT).pop());
  //   handleDispatchPropertyText(value);
  // };

  const onChange = event => {
    const {
      target: { value },
    } = event;

    const parts = value.split(ITEM_TEXT_DELIMITER_TYPE.SPLIT);
    const lastPart = parts.pop();
    if (lastPart.length <= 15) {
      setSearchKeyword(lastPart);
      handleDispatchPropertyText(parts.concat(lastPart).join(','));
    }
  };
  const onChangeForSponsorCookie = event => {
    const {
      target: { value },
    } = event;

    const intValue = parseInt(value, 10); // 문자열을 정수로 변환
    // 숫자 검증: 정수이고 1 이상일 때만 상태 업데이트

    if (!Number.isNaN(intValue) && intValue > 0) {
      handleDispatchPropertyText(intValue.toString());
    } else if (value === '') {
      handleDispatchPropertyText('');
    }

    // if (!isNaN(intValue) && intValue > 0) {
    // handleDispatchPropertyText(intValue.toString());
    // } else {
    // }
    // const parts = value.split(ITEM_TEXT_DELIMITER_TYPE.SPLIT);

    // const lastPart = parts.pop();
    // if (lastPart.length <= 15) {
    //   setSearchKeyword(lastPart);
    //   handleDispatchPropertyText(parts.concat(lastPart).join(','));
    // }
  };

  const onKeyUp = event => {
    const {
      key,
      target: { value },
    } = event;

    if (key === KEYBOARD_KEYS.COMMA) {
      const targetItemName = value.split(ITEM_TEXT_DELIMITER_TYPE.SPLIT).at(-2);
      // const checkedItemName = getCanEnteredAddItemName(targetItemName);

      // if (!checkedItemName) {
      //   showCanNotAddItemSnackBar();
      //   handleDispatchPropertyText(propertyText.replace(`${targetItemName},`, ''));
      // } else {
      handleDispatchProperty();
      showAddItemSnackBar(targetItemName);
      // }
    }
  };

  const onBlur = event => {
    const {
      target: { value },
    } = event;

    const targetItemName = value.split(ITEM_TEXT_DELIMITER_TYPE.SPLIT).pop();
    // const checkedItemName = getCanEnteredAddItemName(targetItemName);
    // if (!checkedItemName) {
    //   showCanNotAddItemSnackBar();
    //   handleDispatchPropertyText(propertyText.replace(`${targetItemName}`, ''));
    // } else {
    handleDispatchProperty();
    showAddItemSnackBar(targetItemName);
    // }
  };

  const onBlurForSponsorCookie = event => {
    const {
      target: { value },
    } = event;

    const targetItemName = value.split(ITEM_TEXT_DELIMITER_TYPE.SPLIT).pop();

    // if (Number(targetItemName) >= 10) {
    //   handleDispatchProperty();
    //   showRequiredSponsorCookieSnackBar('10');
    //   handleDispatchPropertyText('10');
    // } else {
    //   handleDispatchProperty();
    //   showRequiredSponsorCookieSnackBar(targetItemName);
    // }

    if (Number(targetItemName) >= 10) {
      handleDispatchProperty();
      showRequiredSponsorCookieSnackBar('10');
      handleDispatchPropertyText('10');
    } else if (Number(targetItemName) === 0) {
      handleDispatchProperty();
      showRequiredSponsorCookieSnackBar('1');
      handleDispatchPropertyText('1');
    } else {
      console.log('1111');
      handleDispatchProperty();
      showRequiredSponsorCookieSnackBar(targetItemName);
    }
  };

  // const onBlurForSponsorCookie = event => {
  //   const {
  //     target: { value },
  //   } = event;

  //   const targetItemName = value.split(ITEM_TEXT_DELIMITER_TYPE.SPLIT).pop();
  //   if (Number(targetItemName) >= 10) {
  //     handleDispatchProperty();
  //     showAddItemSnackBar('10');
  //     handleDispatchPropertyText('10');
  //   } else {
  //     handleDispatchProperty();
  //     showAddItemSnackBar(targetItemName);
  //   }
  // };

  const onAutoCompleteItemClick = clickedItemName => {
    const targetStoreInputText = propertyText.split(',').slice(0, -1);
    const dispatchPropertyText = targetStoreInputText.length
      ? `${targetStoreInputText},${clickedItemName}`
      : clickedItemName;

    // const checkedItemName = getCanEnteredAddItemName(clickedItemName);
    // if (!checkedItemName) {
    //   showCanNotAddItemSnackBar();
    //   handleDispatchPropertyText(propertyText.replace(clickedItemName, ''));
    // } else {
    handleDispatchPropertyText(dispatchPropertyText);
    showAddItemSnackBar(clickedItemName);
    // }
  };

  return {
    searchKeyword,
    propertyText,
    onChange,
    onDelete,
    onKeyUp,
    onBlur,
    onAutoCompleteItemClick,
    onBlurForSponsorCookie,
    onChangeForSponsorCookie,
  };
};

export default useAutoComplete;

// import { useState, useCallback } from 'react';
// import { useSelector, useDispatch, shallowEqual } from 'react-redux';

// import { KEYBOARD_KEYS } from '@CommonConstants';

// import { CHOICE_KEYS, CHOICE_RESULT_KEYS, ITEM_TEXT_DELIMITER_TYPE } from '@Services/Editor/Constants';

// import {
//   useItemNames,
//   usePropertyTextByType,
//   setChoiceVisibleConditionItems,
//   setChoiceRequired,
//   setChoiceResultStoreProperty,
//   setChoiceResultDestroyProperty,
//   setResultRequiredItemsCondition,
//   updateChoicePropertyChipState,
//   updateResultPropertyChipState,
//   deleteChoiceProperty,
//   deleteChoiceResultProperty,
// } from '@Services/Editor';

// const useAutoComplete = (snackBarRef, type, processId, choiceId, handleCloseContextMenuClick, resultId = null) => {
//   const dispatch = useDispatch();
//   const itemElements = useSelector(useItemNames, shallowEqual);

//   // const proceesses = useSelector(state => state.editor.processes, shallowEqual);
//   const propertyText = useSelector(usePropertyTextByType(type, processId, choiceId, resultId), shallowEqual);
//   const [searchKeyword, setSearchKeyword] = useState('');
//   const isCanItemAdd = type === CHOICE_RESULT_KEYS.STORE;
//   const getIsIncludedItem = itemName => {
//     const splittedItemName = itemName.includes(ITEM_TEXT_DELIMITER_TYPE.MULTIPLE_ITEM)
//       ? itemName.split(ITEM_TEXT_DELIMITER_TYPE.MULTIPLE_ITEM)[0]
//       : itemName;
//     return itemElements.find(name => name === splittedItemName);
//   };

//   // const getAllItems = () =>

//   // const showAddItemSnackBar = itemName => {
//   //   if (!itemName) {
//   //     return;
//   //   }

//   //   const isShowSnackBar = !getIsIncludedItem(itemName);

//   //   if (type === CHOICE_RESULT_KEYS.STORE && isShowSnackBar) {
//   //     snackBarRef.current.show({
//   //       text: `"${itemName}" 아이템 추가됨`,
//   //     });
//   //   }

//   //   handleCloseContextMenuClick();
//   // };

//   const showAddItemSnackBar = itemName => {
//     if (!itemName) {
//       return;
//     }

//     const isShowSnackBar = !getIsIncludedItem(itemName);

//     if (isShowSnackBar) {
//       snackBarRef.current.show({
//         text: `"${itemName}" 아이템 추가됨`,
//       });
//     }

//     handleCloseContextMenuClick();
//   };

//   const showCanNotAddItemSnackBar = () => {
//     snackBarRef.current.show({
//       text: '아이템은 도착지 > 얻는 아이템에서 추가해 주세요.',
//     });
//     handleCloseContextMenuClick();
//   };

//   const getCanEnteredAddItemName = itemName => {
//     if (!itemName) {
//       return true;
//     }

//     if (isCanItemAdd) {
//       return itemName;
//     }

//     const isIncludedItem = getIsIncludedItem(itemName);

//     if (isIncludedItem) {
//       return itemName;
//     }

//     return false;
//   };

//   const handleDispatchProperty = useCallback(() => {
//     switch (type) {
//       case CHOICE_KEYS.HIDE: {
//         dispatch(setChoiceVisibleConditionItems({ processId, choiceId }));
//         break;
//       }

//       case CHOICE_KEYS.REQUIRED: {
//         dispatch(setChoiceRequired({ processId, choiceId }));
//         break;
//       }

//       case CHOICE_RESULT_KEYS.STORE: {
//         dispatch(setChoiceResultStoreProperty({ processId, choiceId, resultId }));
//         break;
//       }

//       case CHOICE_RESULT_KEYS.DESTROY: {
//         dispatch(setChoiceResultDestroyProperty({ processId, choiceId, resultId }));
//         break;
//       }

//       case CHOICE_RESULT_KEYS.CHOICE_RESULT_KEYS: {
//         dispatch(setResultRequiredItemsCondition({ processId, choiceId, resultId }));
//         break;
//       }

//       default:
//         break;
//     }
//     setSearchKeyword('');
//   }, [type, searchKeyword, dispatch]);

//   const handleDispatchPropertyText = useCallback(
//     text => {
//       const isChoiceProperty = type === CHOICE_KEYS.HIDE || type === CHOICE_KEYS.REQUIRED;

//       if (isChoiceProperty) {
//         dispatch(updateChoicePropertyChipState({ processId, choiceId, type, state: text }));
//       } else {
//         dispatch(
//           updateResultPropertyChipState({
//             processId,
//             choiceId,
//             resultId,
//             type,
//             state: text,
//           }),
//         );
//       }
//     },
//     [type, dispatch],
//   );

//   const onDelete = useCallback(() => {
//     switch (type) {
//       case CHOICE_KEYS.HIDE: {
//         dispatch(deleteChoiceProperty({ processId, choiceId, type: CHOICE_KEYS.HIDE }));
//         break;
//       }

//       case CHOICE_KEYS.REQUIRED: {
//         dispatch(deleteChoiceProperty({ processId, choiceId, type: CHOICE_KEYS.REQUIRED }));
//         break;
//       }

//       case CHOICE_RESULT_KEYS.STORE: {
//         dispatch(
//           deleteChoiceResultProperty({
//             processId,
//             choiceId,
//             resultId,
//             type: CHOICE_RESULT_KEYS.STORE,
//           }),
//         );
//         dispatch(
//           deleteChoiceResultProperty({
//             processId,
//             choiceId,
//             resultId,
//             type: CHOICE_RESULT_KEYS.STORE_HIDDEN,
//           }),
//         );

//         break;
//       }

//       case CHOICE_RESULT_KEYS.DESTROY: {
//         dispatch(deleteChoiceResultProperty({ processId, choiceId, resultId, type: CHOICE_RESULT_KEYS.DESTROY }));
//         dispatch(
//           deleteChoiceResultProperty({ processId, choiceId, resultId, type: CHOICE_RESULT_KEYS.DESTROY_HIDDEN }),
//         );
//         break;
//       }

//       case CHOICE_RESULT_KEYS.REQUIRED_ITEMS: {
//         dispatch(
//           deleteChoiceResultProperty({ processId, choiceId, resultId, type: CHOICE_RESULT_KEYS.REQUIRED_ITEMS }),
//         );
//         break;
//       }

//       default:
//         break;
//     }
//   }, [type, dispatch]);

//   const onChange = event => {
//     const {
//       target: { value },
//     } = event;
//     setSearchKeyword(value.split(ITEM_TEXT_DELIMITER_TYPE.SPLIT).pop());
//     handleDispatchPropertyText(value);
//   };

//   const onKeyUp = event => {
//     const {
//       key,
//       target: { value },
//     } = event;

//     if (key === KEYBOARD_KEYS.COMMA) {
//       const targetItemName = value.split(ITEM_TEXT_DELIMITER_TYPE.SPLIT).at(-2);
//       const checkedItemName = getCanEnteredAddItemName(targetItemName);

//       if (!checkedItemName) {
//         showCanNotAddItemSnackBar();
//         handleDispatchPropertyText(propertyText.replace(`${targetItemName},`, ''));
//       } else {
//         handleDispatchProperty();
//         showAddItemSnackBar(targetItemName);
//       }
//     }
//   };

//   const onBlur = event => {
//     const {
//       target: { value },
//     } = event;

//     const targetItemName = value.split(ITEM_TEXT_DELIMITER_TYPE.SPLIT).pop();
//     const checkedItemName = getCanEnteredAddItemName(targetItemName);
//     if (!checkedItemName) {
//       showCanNotAddItemSnackBar();
//       handleDispatchPropertyText(propertyText.replace(`${targetItemName}`, ''));
//     } else {
//       handleDispatchProperty();
//       showAddItemSnackBar(targetItemName);
//     }
//   };

//   const onAutoCompleteItemClick = clickedItemName => {
//     const targetStoreInputText = propertyText.split(',').slice(0, -1);
//     const dispatchPropertyText = targetStoreInputText.length
//       ? `${targetStoreInputText},${clickedItemName}`
//       : clickedItemName;

//     const checkedItemName = getCanEnteredAddItemName(clickedItemName);
//     if (!checkedItemName) {
//       showCanNotAddItemSnackBar();
//       handleDispatchPropertyText(propertyText.replace(clickedItemName, ''));
//     } else {
//       handleDispatchPropertyText(dispatchPropertyText);
//       showAddItemSnackBar(clickedItemName);
//     }
//   };

//   return { searchKeyword, propertyText, onChange, onDelete, onKeyUp, onBlur, onAutoCompleteItemClick };
// };

// export default useAutoComplete;
